import { useState } from "react";

type PaginationType = {
  currentPage: number;
  totalRecords: number;
  recordsPerPage: number;
};

/**
 *
 * @param initialValues An optional object containing initial values for pagination state.
 * @returns A state which has 2 elements: pagination and setPagination
 */
const useCustomPagination = (initialValues: Partial<PaginationType>) => {
  return useState({
    currentPage: 1,
    totalRecords: 0,
    recordsPerPage: 10,
    ...initialValues,
  });
};

export default useCustomPagination;
